import RpcService          from '@/core/services/Rpc/RpcService';
import type RpcResponse    from '@/core/services/Rpc/RpcResponse';
import type Manufacturer   from '@/domains/Manufacturers/Manufacturer';
import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort       from '@/core/services/Rpc/RpcDataSort';


class ManufacturersDAO {

    static async getList(
      filters?: {
          pattern?:   string;
          name?:      string;
          ids?:       number[];
          isDeleted?: boolean;
      },
      pagination?: RpcDataPagination,
      sort?:       RpcDataSort,
    ): Promise<RpcResponse> {
        return await RpcService.makeRequest(
          'manufacturers.getList',
          {
            ...filters,
          },
          pagination,
          sort
        );
    }

    static async add(manufacturer: Manufacturer): Promise<RpcResponse> {
        return await RpcService.makeRequest('manufacturers.add', { manufacturer });
    }

    static async update(manufacturer: Manufacturer): Promise<RpcResponse> {
        return await RpcService.makeRequest('manufacturers.update', { manufacturer });
    }

    static async delete(id: number): Promise<RpcResponse> {
        return await RpcService.makeRequest('manufacturers.delete', { id });
    }
}

export default ManufacturersDAO;
